module.exports = __webpack_public_path__ + "img/posterscope-primary.644bf7c4.svg";